import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { closeDrawer } from '@/core/features/drawer';
import { updateUserRoleRequest } from '@/api/user/updateUserRole';
import { fetchMembers } from '@/slices/members';
import i18n from '@/i18n';
import { updateUserRole } from '../actions';

const updateUserRoleEpic: Epic = (action$) =>
  action$.pipe(
    filter(updateUserRole.match),
    request(({ payload }) => updateUserRoleRequest(payload), updateUserRole),
  );

const updateUserRoleSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(updateUserRole.succeeded.match),
    mergeMap(
      ({
        payload: {
          originalData: { propertyId },
        },
      }) => [
        closeDrawer(),
        openSnackbar({
          snackbarType: 'success',
          snackbarMessage: i18n.t('ROLE_UPDATE_SUCCESS'),
        }),
        fetchMembers({ propertyId }),
      ],
    ),
  );

export default combineEpics(updateUserRoleEpic, updateUserRoleSucceededEpic);
